import React, { memo, useRef } from "react";
import {
  Button,
  DrawerBody,
  DrawerFooter,
  HStack,
  Spacer,
  Stack,
  VStack,
  Text,
} from "@chakra-ui/react";
import ForwardToRelatedMessageThread from "./forward-to-related-message-thread";
import useMessageThreadDraft from "modules/hooks/use-message-thread-draft";
import MessageReply from "modules/messaging/_shared/message-reply";
import colors from "app/colors";
import { IQuillEditorHandle } from "modules/messaging/compose/quill-message-composer";
import { useOverlay } from "modules/providers/overlay-provider";

interface IProps {
  draftId: string;
  onForwardToChangeClicked: () => void;
}

const ForwardToReply = ({ draftId, onForwardToChangeClicked }: IProps) => {
  const { draft } = useMessageThreadDraft({ draftId });
  const { closeDrawer } = useOverlay();
  const quillEditorRef = useRef<IQuillEditorHandle>(null);

  if (!draft || !draft.forwardToMessageThread) return null;

  return (
    <>
      <DrawerBody>
        <Stack pt={3}>
          <VStack w="full" alignItems="flex-start" spacing={1}>
            <Text color={colors.grayMain} fontSize={14}>
              Send To:
            </Text>
            <HStack w="full">
              <Text
                color={colors.gray50}
                fontSize={16}
                fontWeight={700}
                noOfLines={1}
              >
                {draft.forwardToMessageThread.subject}
              </Text>
              <Spacer />
              <Button
                variant="link"
                onClick={onForwardToChangeClicked}
                color={colors.blue}
                fontSize={12}
              >
                Change
              </Button>
            </HStack>
          </VStack>

          <ForwardToRelatedMessageThread
            draftId={draftId}
            quillEditorRef={quillEditorRef}
          />
        </Stack>
      </DrawerBody>

      <DrawerFooter p={0} px={3} h="400px" alignItems="flex-end" w="full">
        <MessageReply
          draftId={draftId}
          messageThread={draft.forwardToMessageThread}
          ref={quillEditorRef}
          onMessageSent={closeDrawer}
        />
      </DrawerFooter>
    </>
  );
};

export default memo(ForwardToReply);
